<h1 mat-dialog-title>Authentification</h1>

<form [formGroup]="loginForm" (ngSubmit)="login()">

    <div class="mat-dialog-content">

        <div class="form-container">

            <div class="form-row">
                <mat-form-field class="full-width" hideRequiredMarker>
                    <mat-label>Adresse mail</mat-label>
                    <input matInput type="text" required formControlName="email">
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field class="full-width" hideRequiredMarker>
                    <mat-label>Mot de passe</mat-label>
                    <input matInput type="password" required formControlName="password">
                    <mat-hint class="mat-hint-action" (click)="requestResetPassword()">Avez-vous oublié votre mot de passe ?</mat-hint>
                </mat-form-field>
            </div>

        </div>

    </div>

    <div class="mat-dialog-actions">
        <button type="submit" mat-raised-button color="primary" [disabled]="!loginForm.valid">Connexion</button>

        <mat-checkbox name="rememberMe" id="rememberMe" (change)="rememberMe = $event.checked" [checked]="rememberMe">Garder la session ouverte</mat-checkbox>
    </div>
</form>
